export const RELOAD_EXPLANATION_TRANSLATION_ID = 'reloadExplanation.bk';
